import React, { useState, useEffect, useRef, useCallback } from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import ReactDOM from 'react-dom';
import css from './DropDown.module.scss';
import classnames from 'classnames';
import { generateUniqueId } from '../../../../common/utils/utils';

const ModalDropDown = ({ refTableChild, modal, modalDropdown, refTable, val, getHandlers }) => {
    const func = useCallback(() => {
        if (modal?.current) {
            const dropDownHeight = modal?.current?.getBoundingClientRect()?.height;
            const dropDownWidth = modal?.current?.getBoundingClientRect()?.width;
            const top =
                modalDropdown?.current?.getBoundingClientRect()?.top -
                refTable?.current.getBoundingClientRect()?.top +
                modalDropdown?.current?.getBoundingClientRect()?.height;
            const bottom =
                modalDropdown?.current?.getBoundingClientRect()?.top -
                refTable?.current.getBoundingClientRect()?.top -
                dropDownHeight;
            const left =
                modalDropdown?.current?.getBoundingClientRect()?.left -
                refTable?.current.getBoundingClientRect()?.left +
                modalDropdown?.current?.getBoundingClientRect()?.width / 2 -
                dropDownWidth / 2;
            const limitBottom = refTableChild?.current.getBoundingClientRect()?.height;
            if (top > limitBottom) {
                modal.current.style.top = `${bottom}px`;
            } else {
                modal.current.style.top = `${top}px`;
            }
            modal.current.style.left = `${left}px`;
        }
    }, [modal, modalDropdown, refTable, refTableChild]);
    useEffect(() => {
        const refTableChildVar = refTableChild?.current;
        func();
        if (refTableChildVar) {
            refTableChildVar.addEventListener('scroll', func);
        }
        return () => {
            refTableChildVar?.removeEventListener('scroll', func);
        };
    }, [func, refTableChild]);
    return (
        <div className={css.dropdownWindow} ref={modal}>
            {val.options
                .filter((option) => !option.hidden)
                .map((el, idx) => (
                    <div key={`dropdownWindow${idx}`} {...getHandlers('change', el.id)} className={css.dropdownWindowElem}>
                        {el.title}
                    </div>
                ))}
        </div>
    );
};
const DropDown = ({ getHandlers, translation, val, refTable, gridName, refTableChild }) => {
    const modal = useRef(null);
    const colors = {
        open: 'var(--blueColor)',
        on_hold: 'var(--orangeDeepColorLight)',
        canceled: 'var(--redDarkColor)',
        postponed: 'var(--orangeColor)',
        rejected: 'var(--brownColor)',
        returned: 'var(--purpleDeepColor)',
        in_delivery: 'var(--blueSkyColor)',
        done: 'var(--greenColor)',
        waiting_for_a_call: 'var(--orangeColor)'
    };
    const ref = useRef();
    const [value, setValue] = useState(val.value || '');
    const [showWindow, setShowWindow] = useState(false);
    const activeElem = val.options.filter((el) => el.id === value);
    useEffect(() => {
        if (val) {
            setValue(val.value);
            setShowWindow(false);
        }
    }, [val]);
    return (
        <div
            ref={ref}
            className={classnames(css.dropdownWrappers, val?.disabled ? css.dropdownWrappersDisabled : {})}
            onClick={() => {
                setShowWindow(!showWindow);
            }}
        >
            <div
                ref={ref}
                style={{
                    backgroundColor: activeElem[0] ? colors[activeElem[0].alias] || colors[activeElem[0].id] : 'grey'
                }}
                className={classnames(css.dropdownElemWrappers)}
            >
                <div className={classnames(css.dropdownElemTitle)} key={generateUniqueId()}>
                    {activeElem[0] ? activeElem[0].title : value}
                </div>
                {!val.disabled && (
                    <div className={showWindow ? css.dropdownElemSvg : ''}>
                        {svgSprite('angle-down', {
                            width: '8px',
                            height: '4px',
                            fill: 'var(--whiteColor)',
                            style: { marginBottom: '3px' }
                        })}
                    </div>
                )}
            </div>
            {!!showWindow &&
                document.getElementById(`${gridName}portalDropdown`) &&
                ReactDOM.createPortal(
                    <ModalDropDown
                        modal={modal}
                        refTable={refTable}
                        getHandlers={getHandlers}
                        modalDropdown={ref}
                        val={val}
                        refTableChild={refTableChild}
                        translation={translation}
                    />,
                    document?.getElementById(`${gridName}portalDropdown`)
                )}
        </div>
    );
};
export default DropDown;
